<template>
  <div
    v-if="isBulletInAvailable && bulletIn"
    :class="`bullet-in bullet-in-${bulletIn.category[0]}`"
  >
    <div
      class="fixed left-0 top-0 z-10 flex w-full items-center justify-between p-2 text-center text-white"
      :class="bulletInColor(bulletIn.category[0])"
    >
      <p class="w-full" v-html="md.render(bulletIn.note)"></p>
      <div class="ml-5">
        <button
          type="button"
          class="transition-all focus:outline-none focus:ring-2 focus:ring-offset-2"
          @click="dismissBulletIn"
        >
          <span class="material-symbols-outlined notranslate" translate="no" aria-hidden="true">
            close
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import markdownit from 'markdown-it'
import { match } from 'ts-pattern'
import { useBulletInStore, BulletNoteCategory } from '@/stores/bulletIn'

const bulletInStore = useBulletInStore()
const { bulletIn, isBulletInAvailable } = storeToRefs(bulletInStore)
const { fetchBulletIn, dismissBulletIn } = bulletInStore

const bulletInColor = (category: BulletNoteCategory): string => {
  return match(category)
    .with(BulletNoteCategory.ERROR, () => 'bg-red-500')
    .with(BulletNoteCategory.INFO, () => 'bg-blue-500')
    .with(BulletNoteCategory.WARN, () => 'bg-yellow-400')
    .exhaustive()
}

onMounted(() => {
  fetchBulletIn()
})

const md = markdownit({
  html: true, // HTMLを許可
  linkify: true, // URLを自動リンクに変換
  typographer: true // タイポグラフィーを自動変換
})
</script>

<style scoped></style>
